export default function Footer() {
  return (
    <footer className="bg-accent-900 text-white">
      {/* Top Section */}
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Column 1: About */}
          <div>
            <h1 className="font-heading text-lg font-bold mb-3 whitespace-nowrap">VigorBuy</h1>
            <p className="text-xs text-white/60 leading-relaxed">
              The #1 VigorBuy Spreadsheet Directory. Browse 10,000+ verified products across 14 categories with trusted seller reviews, QC photos, and complete buying guides.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <p className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-4">Guides</p>
            <div className="flex flex-col gap-2.5">
              <a href="/vigorbuy-sheet-guide" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">Complete Guide 2026</a>
              <a href="/vigorbuy-sheet-guide" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">Safe Buying Tips</a>
              <a href="/vigorbuy-sheet-guide" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">Shipping Information</a>
            </div>
          </div>

          {/* Column 3: Categories */}
          <div>
            <p className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-4">Top Categories</p>
            <div className="flex flex-col gap-2.5">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">Shoes</a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">Hoodies/Sweaters</a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">T-Shirts</a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap">Jackets</a>
            </div>
          </div>

          {/* Column 4: Legal */}
          <div>
            <p className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-4">Legal</p>
            <div className="flex flex-col gap-2.5">
              <a href="#" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Terms of Use</a>
              <a href="#" className="text-sm text-white/70 hover:text-white transition-colors duration-200 whitespace-nowrap cursor-pointer">Disclaimer</a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-8 md:py-12">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <p className="text-center text-4xl md:text-7xl lg:text-8xl font-heading font-bold text-white/15 select-none whitespace-nowrap">
            VIGORBUY
          </p>
          <p className="text-center text-xs text-white/40 mt-4">
            &copy; {new Date().getFullYear()} VigorBuy Spreadsheet Directory. All rights reserved. This site is not affiliated with VigorBuy.
          </p>
        </div>
      </div>
    </footer>
  );
}